import React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import BlockIcon from '@mui/icons-material/Block';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Typography from '@mui/material/Typography';


export default function Home() {
    return (
        <Box
            component="main"
            sx={{
                backgroundColor: (theme) =>
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[900],
                flexGrow: 1,
                height: '100vh',
                overflow: 'auto',
            }}
        >
            <Toolbar />
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                <Grid container spacing={3}>
                    {/* Recent Orders */}
                    <Grid item xs={12}>
                        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'row', alignItems: 'center', mb: 2 }}>
                            <BlockIcon style={{ marginRight: 5, color: '#f44336' }} />
                            <Typography variant="body2" sx={{ color: '#616161' }}>
                                Te recordamos que queda terminantemente prohibido el uso del celular durante el exámen.
                            </Typography>
                        </Paper>
                        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'row', mb: 2 }}>
                            <TimerOutlinedIcon style={{ marginRight: 5, color: '#20dfb1' }} />
                            <Box sx={{ color: '#616161' }}>
                                <Typography component="div" sx={{ fontWeight: 500 }}>
                                    TIEMPO PARA RENDIR LOS EXAMENES
                                </Typography>
                                <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                                    El tiempo se comienza a contar desde que hacés click en el botón INICIAR EXAMEN ubicado a la derecha del nombre de la materia a rendir.
                                </Typography>
                                <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                                    La duración dependerá del tipo de examen:
                                </Typography>
                                <Box component="ul" sx={{ pl: 2, my: 1 }}>
                                    <Box component="li" sx={{ fontSize: '0.875rem' }}>
                                        <Box component="span" sx={{ fontWeight: 500 }}>Parciales</Box>: 40 minutos
                                    </Box>
                                    <Box component="li" sx={{ fontSize: '0.875rem' }}>
                                        <Box component="span" sx={{ fontWeight: 500 }}>Integradores</Box>: 60 minutos
                                    </Box>
                                    <Box component="li" sx={{ fontSize: '0.875rem' }}>
                                        <Box component="span" sx={{ fontWeight: 500 }}>Finales</Box>: 90 minutos
                                    </Box>
                                </Box>
                                <Typography component="div" variant="body2">
                                    Tené en cuenta que al cabo de este tiempo, el examen se cerrará automáticamente aunque no lo hayas finalizado.
                                </Typography>
                            </Box>
                        </Paper>
                        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'row', mb: 2 }}>
                            <VisibilityOutlinedIcon style={{ marginRight: 5, color: '#20dfb1' }} />
                            <Box sx={{ color: '#616161' }}>
                                <Typography component="div" sx={{ fontWeight: 500 }}>
                                    IMPORTANTE: INFORMACIÓN AL FINALIZAR TU EXAMEN
                                </Typography>
                                <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                                    Al presionar el botón FINALIZAR EXAMEN visualizarás una pantalla con la siguiente información:
                                </Typography>
                                <Box component="ul" sx={{ pl: 2, my: 1 }}>
                                    {['APROBADO o DESAPROBADO', 'NOTA OBTENIDA', 'PREGUNTAS CORRECTAS', 'PREGUNTAS INCORRECTAS'].map((item) => (
                                        <Box component="li" key={item} sx={{ fontSize: '0.875rem' }}>
                                            {item}
                                        </Box>
                                    ))}
                                </Box>
                                <Typography component="div" variant="body2">
                                    Te recomendamos que antes de salir de esta pantalla verifiques esta información con atención.
                                </Typography>
                            </Box>
                        </Paper>
                        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'row', mb: 2 }}>
                            <CheckCircleOutlineIcon style={{ marginRight: 5, color: '#20dfb1' }} />
                            <Box sx={{ color: '#616161' }}>
                                <Typography component="div" sx={{ fontWeight: 500 }}>
                                    REVISIÓN DE PREGUNTAS AL FINALIZAR EL EXAMEN
                                </Typography>
                                <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                                    En la pantalla final de tu examen podrás verificar las respuestas elegidas, la justificación (en caso de que tengas preguntas incorrectas) y además podrás pedir la revisión de las mismas si fuera necesario.
                                </Typography>
                                <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                                    El tiempo de revisión es de entre 10 y 15 minutos dependiendo del examen.
                                </Typography>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    )
}
